import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { createEmpleado } from '../../../controller/empleadoController'; // Asegúrate de que esta ruta sea correcta
import { fetchSucursales } from '../../../controller/sucursalController'; // Ruta de la función que obtiene las sucursales
import Empleado from '../../../models/Empleado'; // Ruta de tu modelo de Empleado
import { fetchTurnosSemanales } from '../../../controller/TurnoController'; // Ajusta la ruta si es distinta

function EmpleadosCreateView() {
  const navigate = useNavigate();
  const [empleado, setEmpleado] = useState(new Empleado({})); // Estado inicial con el modelo de Empleado
  const [sucursales, setSucursales] = useState([]); // Estado para las sucursales
  const [turnos, setTurnos] = useState([]);  // Cargar las sucursales al montar el componente
  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        const dataSucursales = await fetchSucursales();
        setSucursales(dataSucursales);
        if (dataSucursales.length > 0) {
          setEmpleado((prev) => ({ ...prev, sucursal: dataSucursales[0].id }));
        }

        const dataTurnos = await fetchTurnosSemanales();
        setTurnos(dataTurnos);
        if (dataTurnos.length > 0) {
          setEmpleado((prev) => ({ ...prev, turno_semanal: dataTurnos[0].id }));
        }
      } catch (error) {
        console.error('Error al obtener datos:', error);
      }
    };

    obtenerDatos();
  }, []);

  // Manejar los cambios en el formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmpleado({
      ...empleado,
      [name]: value,
    });
  };

  // Enviar el formulario para crear el empleado
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Convertimos sucursal a número antes de enviarlo
      const empleadoConSucursalNumerica = {
        ...empleado,
        sucursal: parseInt(empleado.sucursal, 10), // Convertir a entero base 10
        turno_semanal: parseInt(empleado.turno_semanal, 10),
      };

      console.log(empleadoConSucursalNumerica);
      await createEmpleado(empleadoConSucursalNumerica); // Llamada a la función de creación del empleado
      navigate('/empleados'); // Redirige a la lista de empleados o página anterior
    } catch (error) {
      console.error('Error al crear el empleado:', error);
    }
  };

  return (
    <Container className="mt-4">
      <Row className="align-items-center mb-4">
        <Col><h1>Crear Empleado</h1></Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type="text"
            name="nombre"
            value={empleado.nombre}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Cedula</Form.Label>
          <Form.Control
            type="text"
            name="cedula"
            value={empleado.cedula}
            onChange={handleChange}
            required
          />
        </Form.Group>



        <Form.Group className="mb-3">
          <Form.Label>Privilegio</Form.Label>
          <Form.Control
            as="select"
            name="privilegio"
            value={empleado.privilegio || 'usuario'} // Valor por defecto: 'usuario'
            onChange={handleChange}
          >
            <option value={1}>Usuario</option>
            <option value={2}>Administrador</option>
          </Form.Control>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Posicion</Form.Label>
          <Form.Control
            type="text"
            name="posicion"
            value={empleado.posicion}
            onChange={handleChange}
          />
        </Form.Group>

        {/* Menú desplegable para seleccionar una sucursal */}
        <Form.Group className="mb-3">
          <Form.Label>Sucursal</Form.Label>
          <Form.Control
            as="select"
            name="sucursal"
            value={empleado.sucursal}
            onChange={handleChange}
            required
          >
            {sucursales.length === 0 ? (
              <option value="">Cargando...</option>
            ) : (
              sucursales.map((sucursal) => (
                <option key={sucursal.id} value={sucursal.id}>
                  {sucursal.name}
                </option>
              ))
            )}
          </Form.Control>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Turno Semanal</Form.Label>
          <Form.Control
            as="select"
            name="turno_semanal"
            value={empleado.turno_semanal}
            onChange={handleChange}
            
          >
            {turnos.length === 0 ? (
              <option value="">Cargando turnos...</option>
            ) : (
              turnos.map((turno) => (
                <option key={turno.id} value={turno.id}>
                  {turno.nombre}
                </option>
              ))
            )}
          </Form.Control>
        </Form.Group>



        <Button variant="primary" type="submit" className="me-2">
          Crear Empleado
        </Button>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Volver
        </Button>
      </Form>
    </Container>
  );
}

export default EmpleadosCreateView;
